{
  "amount_to_pay": "Amount to pay",
  "booking_number": "Booking number",
  "deposit": "Amount to pay now (deposit)",
  "description": "To confirm your booking, please proceed with the upfront payment.",
  "estimated_amount_in_ca_dollars": "Amount in CAD",
  "estimated_amount_in_dollars": "USD equivalent",
  "estimated_amount_in_us_dollars": "Amount in USD",
  "full_amount": "Amount to pay now (full amount)",
  "generic_error": "There was issue with the payment. Please contact your credit card provider or bank before trying again.",
  "interac": {
    "contact": "Questions? Email <a class=\"underline text-primary\" href=\"{{href}}\">info@boatbiketours.com</a>",
    "converted_at": "Converted at {{eur}} ≈ {{cad}} — rate locked until {{valid_until}}",
    "copy": "Copy",
    "description": "Send an Interac e-Transfer from your Canadian bank's online banking or app. We'll confirm your booking once the transfer is received.",
    "quote_validity": "This quote is valid for <strong>5 days</strong> — until {{valid_until}}. After that the CAD amount will be recalculated at the current rate.",
    "sent": "I've sent the e-Transfer",
    "steps": {
      "amount": {
        "hint": "Send the exact amount. Other amounts will delay confirmation.",
        "title": "Amount"
      },
      "recipient": {
        "hint": "Add this as a payee in your online banking.",
        "title": "Send to (email)"
      },
      "reference": {
        "hint": "Paste this into the message field so we can match the payment to your booking.",
        "title": "Reference / Message"
      }
    },
    "title": "Interac Instructions"
  },
  "local_costs": "Local costs (to be paid at departure)",
  "methods": {
    "card": {
      "description": "Credit card or ACH",
      "title": "Pay in USD"
    },
    "interac": {
      "badge": "NEW · CA",
      "description": "e-Transfer with Interac",
      "title": "Pay in CAD"
    }
  },
  "north_america_disclaimer": "<b>Special Note:</b> For guests residing in the US or Canada, bookings are processed through Boat Bike Tours North America Inc. While travel packages are invoiced in Euros, payment is made in US Dollars. The exchange rate is based on the mid-market rate and a bank processing fee is included in the conversion rate. If ACH payment is used, it may take 4-5 business days to process the payment.",
  "paid_amount_in_dollars": "Amount paid in USD",
  "pay_deposit": "Pay deposit instead",
  "pay_full_amount": "Pay full amount instead",
  "payment_completed_description_deposit": "Your deposit payment has been received.",
  "payment_completed_description_full": "Your full payment has been received.",
  "payment_completed_description_interac": "Your payment is on its way. We'll send you a confirmation email once your Interac e-Transfer has been received.",
  "payment_completed_title": "Thank you for your payment",
  "payment_description": "Please proceed with the payment for your booking.",
  "payment_status": "Payment status",
  "payment_title": "Fulfill your outstanding payment",
  "powered_by_stripe": "Powered by Stripe",
  "processing_message": "The payment is currently in ‘Processing’ status. It may take 4-5 business days until the it reconciles with your booking. You will then receive a payment confirmation and your booking confirmation.",
  "retry": "Retry",
  "safe_secure_checkout": "Guaranteed <1>safe & secure</1> checkout",
  "status": {
    "canceled": "Failed",
    "processing": "Processing",
    "succeeded": "Succeeded"
  },
  "title": "Thank you for booking with us!",
  "total_amount": "Total booking amount"
}
